/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SettlementPaymentDto } from '../models';
// @ts-ignore
import type { SettlementPaymentPaidRequestDto } from '../models';
// @ts-ignore
import type { SettlementPaymentRequestDto } from '../models';
// @ts-ignore
import type { SettlementQuoteDto } from '../models';
// @ts-ignore
import type { SettlementQuoteRequestDto } from '../models';
// @ts-ignore
import type { SettlementsDto } from '../models';
/**
 * RestSettlementsApi - axios parameter creator
 */
export const RestSettlementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dodanie płatności
         * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSettlementPayment: async (settlementPaymentRequestDto: SettlementPaymentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settlementPaymentRequestDto' is not null or undefined
            assertParamExists('createSettlementPayment', 'settlementPaymentRequestDto', settlementPaymentRequestDto)
            const localVarPath = `/api/settlements/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settlementPaymentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dodanie wyceny
         * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSettlementQuote: async (settlementQuoteRequestDto: SettlementQuoteRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settlementQuoteRequestDto' is not null or undefined
            assertParamExists('createSettlementQuote', 'settlementQuoteRequestDto', settlementQuoteRequestDto)
            const localVarPath = `/api/settlements/quotes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settlementQuoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Usunięcie płatności
         * @param {string} settlementPaymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSettlementPayment: async (settlementPaymentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settlementPaymentId' is not null or undefined
            assertParamExists('deleteSettlementPayment', 'settlementPaymentId', settlementPaymentId)
            const localVarPath = `/api/settlements/payments/{settlementPaymentId}`
                .replace('{settlementPaymentId}', encodeURIComponent(String(settlementPaymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Usunięcie wyceny
         * @param {string} settlementQuoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSettlementQuote: async (settlementQuoteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settlementQuoteId' is not null or undefined
            assertParamExists('deleteSettlementQuote', 'settlementQuoteId', settlementQuoteId)
            const localVarPath = `/api/settlements/quotes/{settlementQuoteId}`
                .replace('{settlementQuoteId}', encodeURIComponent(String(settlementQuoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wszystkie wyceny i płatności, najnowsze pierwsze, z bilansem policzonym z tych wpisów. Wymaga uprawnienia MANAGE_SETTLEMENTS. 
         * @summary Wyceny, płatności i bilans rozliczeń
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlements: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zmiana płatności
         * @param {string} settlementPaymentId 
         * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementPayment: async (settlementPaymentId: string, settlementPaymentRequestDto: SettlementPaymentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settlementPaymentId' is not null or undefined
            assertParamExists('updateSettlementPayment', 'settlementPaymentId', settlementPaymentId)
            // verify required parameter 'settlementPaymentRequestDto' is not null or undefined
            assertParamExists('updateSettlementPayment', 'settlementPaymentRequestDto', settlementPaymentRequestDto)
            const localVarPath = `/api/settlements/payments/{settlementPaymentId}`
                .replace('{settlementPaymentId}', encodeURIComponent(String(settlementPaymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settlementPaymentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Oznaczenie płatności jako zapłaconej albo niezapłaconej
         * @param {string} settlementPaymentId 
         * @param {SettlementPaymentPaidRequestDto} settlementPaymentPaidRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementPaymentPaid: async (settlementPaymentId: string, settlementPaymentPaidRequestDto: SettlementPaymentPaidRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settlementPaymentId' is not null or undefined
            assertParamExists('updateSettlementPaymentPaid', 'settlementPaymentId', settlementPaymentId)
            // verify required parameter 'settlementPaymentPaidRequestDto' is not null or undefined
            assertParamExists('updateSettlementPaymentPaid', 'settlementPaymentPaidRequestDto', settlementPaymentPaidRequestDto)
            const localVarPath = `/api/settlements/payments/{settlementPaymentId}/paid`
                .replace('{settlementPaymentId}', encodeURIComponent(String(settlementPaymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settlementPaymentPaidRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zmiana wyceny
         * @param {string} settlementQuoteId 
         * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementQuote: async (settlementQuoteId: string, settlementQuoteRequestDto: SettlementQuoteRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'settlementQuoteId' is not null or undefined
            assertParamExists('updateSettlementQuote', 'settlementQuoteId', settlementQuoteId)
            // verify required parameter 'settlementQuoteRequestDto' is not null or undefined
            assertParamExists('updateSettlementQuote', 'settlementQuoteRequestDto', settlementQuoteRequestDto)
            const localVarPath = `/api/settlements/quotes/{settlementQuoteId}`
                .replace('{settlementQuoteId}', encodeURIComponent(String(settlementQuoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settlementQuoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestSettlementsApi - functional programming interface
 */
export const RestSettlementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestSettlementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Dodanie płatności
         * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSettlementPayment(settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettlementPaymentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSettlementPayment(settlementPaymentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.createSettlementPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dodanie wyceny
         * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSettlementQuote(settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettlementQuoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSettlementQuote(settlementQuoteRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.createSettlementQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Usunięcie płatności
         * @param {string} settlementPaymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSettlementPayment(settlementPaymentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSettlementPayment(settlementPaymentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.deleteSettlementPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Usunięcie wyceny
         * @param {string} settlementQuoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSettlementQuote(settlementQuoteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSettlementQuote(settlementQuoteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.deleteSettlementQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wszystkie wyceny i płatności, najnowsze pierwsze, z bilansem policzonym z tych wpisów. Wymaga uprawnienia MANAGE_SETTLEMENTS. 
         * @summary Wyceny, płatności i bilans rozliczeń
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSettlements(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettlementsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSettlements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.getSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zmiana płatności
         * @param {string} settlementPaymentId 
         * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettlementPayment(settlementPaymentId: string, settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettlementPayment(settlementPaymentId, settlementPaymentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.updateSettlementPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Oznaczenie płatności jako zapłaconej albo niezapłaconej
         * @param {string} settlementPaymentId 
         * @param {SettlementPaymentPaidRequestDto} settlementPaymentPaidRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettlementPaymentPaid(settlementPaymentId: string, settlementPaymentPaidRequestDto: SettlementPaymentPaidRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettlementPaymentPaid(settlementPaymentId, settlementPaymentPaidRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.updateSettlementPaymentPaid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zmiana wyceny
         * @param {string} settlementQuoteId 
         * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSettlementQuote(settlementQuoteId: string, settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSettlementQuote(settlementQuoteId, settlementQuoteRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSettlementsApi.updateSettlementQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestSettlementsApi - factory interface
 */
export const RestSettlementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestSettlementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Dodanie płatności
         * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSettlementPayment(settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SettlementPaymentDto> {
            return localVarFp.createSettlementPayment(settlementPaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dodanie wyceny
         * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSettlementQuote(settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SettlementQuoteDto> {
            return localVarFp.createSettlementQuote(settlementQuoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Usunięcie płatności
         * @param {string} settlementPaymentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSettlementPayment(settlementPaymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSettlementPayment(settlementPaymentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Usunięcie wyceny
         * @param {string} settlementQuoteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSettlementQuote(settlementQuoteId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSettlementQuote(settlementQuoteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Wszystkie wyceny i płatności, najnowsze pierwsze, z bilansem policzonym z tych wpisów. Wymaga uprawnienia MANAGE_SETTLEMENTS. 
         * @summary Wyceny, płatności i bilans rozliczeń
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettlements(options?: RawAxiosRequestConfig): AxiosPromise<SettlementsDto> {
            return localVarFp.getSettlements(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zmiana płatności
         * @param {string} settlementPaymentId 
         * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementPayment(settlementPaymentId: string, settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSettlementPayment(settlementPaymentId, settlementPaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Oznaczenie płatności jako zapłaconej albo niezapłaconej
         * @param {string} settlementPaymentId 
         * @param {SettlementPaymentPaidRequestDto} settlementPaymentPaidRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementPaymentPaid(settlementPaymentId: string, settlementPaymentPaidRequestDto: SettlementPaymentPaidRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSettlementPaymentPaid(settlementPaymentId, settlementPaymentPaidRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zmiana wyceny
         * @param {string} settlementQuoteId 
         * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettlementQuote(settlementQuoteId: string, settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSettlementQuote(settlementQuoteId, settlementQuoteRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestSettlementsApi - interface
 */
export interface RestSettlementsApiInterface {
    /**
     * 
     * @summary Dodanie płatności
     * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSettlementPayment(settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SettlementPaymentDto>;

    /**
     * 
     * @summary Dodanie wyceny
     * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSettlementQuote(settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SettlementQuoteDto>;

    /**
     * 
     * @summary Usunięcie płatności
     * @param {string} settlementPaymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSettlementPayment(settlementPaymentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Usunięcie wyceny
     * @param {string} settlementQuoteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSettlementQuote(settlementQuoteId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Wszystkie wyceny i płatności, najnowsze pierwsze, z bilansem policzonym z tych wpisów. Wymaga uprawnienia MANAGE_SETTLEMENTS. 
     * @summary Wyceny, płatności i bilans rozliczeń
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettlements(options?: RawAxiosRequestConfig): AxiosPromise<SettlementsDto>;

    /**
     * 
     * @summary Zmiana płatności
     * @param {string} settlementPaymentId 
     * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettlementPayment(settlementPaymentId: string, settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Oznaczenie płatności jako zapłaconej albo niezapłaconej
     * @param {string} settlementPaymentId 
     * @param {SettlementPaymentPaidRequestDto} settlementPaymentPaidRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettlementPaymentPaid(settlementPaymentId: string, settlementPaymentPaidRequestDto: SettlementPaymentPaidRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Zmiana wyceny
     * @param {string} settlementQuoteId 
     * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettlementQuote(settlementQuoteId: string, settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestSettlementsApi - object-oriented interface
 */
export class RestSettlementsApi extends BaseAPI implements RestSettlementsApiInterface {
    /**
     * 
     * @summary Dodanie płatności
     * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSettlementPayment(settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).createSettlementPayment(settlementPaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dodanie wyceny
     * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSettlementQuote(settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).createSettlementQuote(settlementQuoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Usunięcie płatności
     * @param {string} settlementPaymentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSettlementPayment(settlementPaymentId: string, options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).deleteSettlementPayment(settlementPaymentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Usunięcie wyceny
     * @param {string} settlementQuoteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSettlementQuote(settlementQuoteId: string, options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).deleteSettlementQuote(settlementQuoteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wszystkie wyceny i płatności, najnowsze pierwsze, z bilansem policzonym z tych wpisów. Wymaga uprawnienia MANAGE_SETTLEMENTS. 
     * @summary Wyceny, płatności i bilans rozliczeń
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSettlements(options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).getSettlements(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zmiana płatności
     * @param {string} settlementPaymentId 
     * @param {SettlementPaymentRequestDto} settlementPaymentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSettlementPayment(settlementPaymentId: string, settlementPaymentRequestDto: SettlementPaymentRequestDto, options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).updateSettlementPayment(settlementPaymentId, settlementPaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Oznaczenie płatności jako zapłaconej albo niezapłaconej
     * @param {string} settlementPaymentId 
     * @param {SettlementPaymentPaidRequestDto} settlementPaymentPaidRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSettlementPaymentPaid(settlementPaymentId: string, settlementPaymentPaidRequestDto: SettlementPaymentPaidRequestDto, options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).updateSettlementPaymentPaid(settlementPaymentId, settlementPaymentPaidRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zmiana wyceny
     * @param {string} settlementQuoteId 
     * @param {SettlementQuoteRequestDto} settlementQuoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSettlementQuote(settlementQuoteId: string, settlementQuoteRequestDto: SettlementQuoteRequestDto, options?: RawAxiosRequestConfig) {
        return RestSettlementsApiFp(this.configuration).updateSettlementQuote(settlementQuoteId, settlementQuoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

